import React, { useMemo, useCallback } from "react";
import { parseCron, buildCron } from "./cronUtils";

const FREQ_OPTIONS = [
    { id: "minutes", label: "Minuty" },
    { id: "hours", label: "Godziny" },
    { id: "days", label: "Dni" },
];

const MINUTE_INTERVALS = [1, 2, 5, 10, 15, 20, 30];
const HOUR_INTERVALS = [1, 2, 3, 4, 6, 8, 12];
const DAY_INTERVALS = [1, 2, 3, 7, 14];

const HOURS = Array.from({ length: 24 }, (_, i) => i);
const MINUTES = Array.from({ length: 60 }, (_, i) => i);

const pad = (n) => String(n).padStart(2, "0");

export function CronScheduleEditor({ value, onChange }) {
    const schedule = useMemo(() => parseCron(value), [value]);

    const update = useCallback(
        (changes) => {
            onChange(buildCron({ ...schedule, ...changes }));
        },
        [schedule, onChange]
    );

    const handleFrequency = useCallback(
        (e) => {
            const frequency = e.target.value;
            const defaults = { minutes: 5, hours: 1, days: 1 };
            update({
                frequency,
                every: defaults[frequency],
                minute: schedule.minute || 0,
                hour: schedule.hour || 0,
            });
        },
        [update, schedule]
    );

    const intervals =
        schedule.frequency === "minutes"
            ? MINUTE_INTERVALS
            : schedule.frequency === "hours"
              ? HOUR_INTERVALS
              : DAY_INTERVALS;

    return (
        <div className={"rows gap-sm"}>
            <div className={"cols cols-middle gap-sm"}>
                <span className={"color-text-secondary type-sm"}>
                    Powtarzaj co
                </span>
                <select
                    className={"cron-select"}
                    value={schedule.every}
                    onChange={(e) =>
                        update({ every: parseInt(e.target.value) })
                    }
                >
                    {intervals.map((n) => (
                        <option key={n} value={n}>
                            {n}
                        </option>
                    ))}
                </select>
                <select
                    className={"cron-select"}
                    value={schedule.frequency}
                    onChange={handleFrequency}
                >
                    {FREQ_OPTIONS.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            </div>

            {schedule.frequency === "hours" && (
                <div className={"cols cols-middle gap-sm"}>
                    <span className={"color-text-secondary type-sm"}>
                        O minucie
                    </span>
                    <select
                        className={"cron-select"}
                        value={schedule.minute || 0}
                        onChange={(e) =>
                            update({ minute: parseInt(e.target.value) })
                        }
                    >
                        {MINUTES.map((m) => (
                            <option key={m} value={m}>
                                :{pad(m)}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {schedule.frequency === "days" && (
                <div className={"cols cols-middle gap-sm"}>
                    <span className={"color-text-secondary type-sm"}>
                        O godzinie
                    </span>
                    <select
                        className={"cron-select"}
                        value={schedule.hour || 0}
                        onChange={(e) =>
                            update({ hour: parseInt(e.target.value) })
                        }
                    >
                        {HOURS.map((h) => (
                            <option key={h} value={h}>
                                {pad(h)}
                            </option>
                        ))}
                    </select>
                    <span className={"color-text-secondary"}>:</span>
                    <select
                        className={"cron-select"}
                        value={schedule.minute || 0}
                        onChange={(e) =>
                            update({ minute: parseInt(e.target.value) })
                        }
                    >
                        {MINUTES.map((m) => (
                            <option key={m} value={m}>
                                {pad(m)}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );
}

CronScheduleEditor.defaultProps = {};

export default CronScheduleEditor;